"use client";

import { useLocale, useTranslations } from "next-intl";
import { useState, type FormEvent } from "react";
import { sendJson } from "@/components/send-json/send-json";
import { useNotify } from "@/components/toaster/app-toaster";

/** The state of the sign-up form: whether the confirmation email was sent, whether it is sending, and `submit` (sends the form to the API and shows a message when it fails). */
export function useSignup() {
  const t = useTranslations("publicBlog.newsletter");
  const locale = useLocale();
  const notify = useNotify();
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    setBusy(true);
    const result = await sendJson("POST", "/api/newsletter/subscribe", { email: data.get("email"), firstName: data.get("firstName"), website: data.get("website"), locale });
    setBusy(false);
    if (result.ok) return setSent(true);
    notify.error(result.error === "slow-down" ? t("slowDown") : t("error"));
  }
  return { sent, busy, submit };
}
